import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../core/services/utils.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../core/services/auth.service';

@Component({
  selector: 'app-template-page',
  templateUrl: './template-page.component.html',
  styleUrls: ['./template-page.component.scss']
})
export class TemplatePageComponent implements OnInit {
  events: string[] = [];
  opened: boolean;
  public displayNav: boolean;
  showFiller = false;
  stylesheetString = "aft-theme";
  displayNavConf: boolean;
  currentUrl: string = '';
  routerSubscription: Subscription;
  settings: boolean = false;
  customPageConf: boolean;
  allowedUrls = ['/app/newTracking', '/app/newTracking/journey']

  constructor(private utilsService: UtilsService, private router: Router, private authService: AuthService) {
    this.routerSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        const navEnd = event as NavigationEnd; // type assertion sicura
        this.currentUrl = navEnd.urlAfterRedirects;
       // console.log('Pagina attuale:', this.currentUrl);
        this.customPageConf = this.authService.isFeatureGranted("customPageConf", "write");
        this.settings = this.allowedUrls.includes(this.currentUrl);

        if (!this.settings) {
           this.settings = false;
        }
        // if (this.currentUrl === '/app/newTracking') {
        //   this.settings = true;
        // } else {
        //   this.settings = false;
        // }
      });
  }

  ngOnInit(): void {
    this.stylesheetString = this.utilsService.getStylesheetString() + "-theme";
    this.displayNav = true;
    this.customPageConf = this.authService.isFeatureGranted('customPageConf', 'write') ?? false;
  }

  toggleNav() {
    this.displayNav = !this.displayNav;
    console.log('Navigazione:', this.displayNav);
  }

  // toggleNavConf() {
  //   if (this.settings){
  //     this.displayNavConf = !this.displayNavConf;
  //   }else{
  //     this.displayNavConf = false;
  //   }
  // }

  // closeNavConf(e) {
  //   this.displayNavConf = e;
  // }


}
